import styled from 'styled-components'

interface IFileViewerStyledProps {}

export const FileViewerStyled = styled.div<IFileViewerStyledProps>`
  display: grid;
  height: 100%;
  width: 100%;

  min-width: ${(props) => props.theme.typography.pxToRem(300)};
  min-height: ${(props) => props.theme.typography.pxToRem(600)};

  background-color: ${(props) => props.theme.colors.contentBackground};

  grid-template-rows: 1fr min-content;
  grid-template-areas:
    'preview'
    'controls';
`
